import { Link } from '@avensia/scope';
import { styled, applyClassName } from '@glitz/react';

export default styled(applyClassName(Link));
